<script>
	import Ribbon from '../../../assets/ribbon.svelte';
	export let width;
	export let height;
	export let text;
	export let fontSize;
	let lineHeight;

	$: if (fontSize) {
		lineHeight = fontSize * 1.4;
	}
</script>

<div class="ribbon-container" style="--width: {width}px; --height: {height}px">
	<div class="ribbon-svg">
		<Ribbon />
	</div>
	<div class="ribbon-textContainer">
		<span class="ribbon-text" style="--fontSize: {fontSize}px; --lineHeight: {lineHeight}px;"
			>{text}</span
		>
	</div>
</div>

<style>
	.ribbon-container {
		width: var(--width);
		height: var(--height);
		position: relative;
	}
	.ribbon-svg {
		width: 100%;
		height: 100%;
		position: absolute;
	}
	.ribbon-textContainer {
		width: 100%;
		height: 100%;
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.ribbon-text {
		font-family: Pally;
		font-style: normal;
		font-weight: 500;
		font-size: var(--fontSize);
		line-height: var(--lineHeight);
		color: var(--base-d-60);
	}
</style>
